// extracted by mini-css-extract-plugin
export default {"titleAnalytics":"style_titleAnalytics__bySSs","bodyAnalytics":"style_bodyAnalytics__QIjTy"};